import { apiService } from "../../services/apiService";
import { apiServiceConstants } from "../../constants/";
import { utilService } from "../../services";

const getMembershipPlan = async (reqParams: {}): Promise<any> => {
  return await apiService
    .apiCall(
      // network_type_id=1 is the open network. Without it the API returns
      // the plans of every network type, and the list showed "Free" twice.
      `open-network/subscription-plans/list?reg_code=${utilService.getNetwork()}&network_type_id=1`,
      reqParams,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      
      return {
       
        
        isSuccess: response.isSuccess,
        message: response.message,
        result:response.result
      } as any;
    })
    .catch((err) => {
      return {
        responseData: [],
        isSuccess: err.isSuccess,
        message: err.message,
      } as any;
    });
};


export const MembershipPlanService = {
  getMembershipPlan,

};
